import React, { useState, useEffect } from 'react';
import { convertUTCToJST, extractDateAndTime } from '../../utils/common.fucntion'

const DETAILS_KEY_BY_TYPE = {
  1: 'inventory',
  2: 'evaluation',
  3: 'followup',
  4: 'inventory', // ICT initial inventory
  5: 'inventory', // ICT post inventory
  6: 'evaluation', // ICT evaluation
  7: 'followup', // ICT followup
};

function QuestionSubHeader(props) {

  const workshop = props?.data?.workshop;
  const [windowWidth, setWindowWidth] = useState(window.innerWidth); //calculate the screen width
  const detailsKey = DETAILS_KEY_BY_TYPE[props?.type] || 'inventory';
  const details = props?.data?.[detailsKey] || {};
  const serviceType = props?.serviceType;
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    // Cleanup function to remove the event listener when component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const getClassName = () => {
    return serviceType === "ict" ? "ict_bg" : "three_mins_bg";
  };

  return (
    <>
      <div className={getClassName()} data-testid="question-sub-header">
        <div className="container w40 max-width-900">
          <div className="row">
            <div className="col-md-9 ">
              <div className="inv_sep" style={{ padding: props.type === 2 || props.type === 6 ? '10px' : '' }}>
                <h3 className="inv_head marginBottom_-5px">{details?.code || workshop?.code}</h3>
                {(props?.type !== 2 || props?.type !== 6) && <div className="inv_subhead">{details?.name}{props.isRes && ((props?.type === 1 || props?.type === 4 || props?.type === 5) ? (<span>(結果)</span>) : (<span>(回答)</span>))}</div>}
                {(props?.type === 2 || props?.type === 6) && <div className="inv_subhead">{workshop?.name}{props.isRes && (<span>(回答)</span>)}</div>}
                <div className="inv_small marginTop_5px">{workshop?.code}&nbsp; {workshop?.name}</div>
              </div>
            </div>
            <>
              {windowWidth >= 769 && (
                <div className="col-md-3 d-flex align-items-center justify-content-start pl-4">
                  <div className="text-start gapbottom pt-2">
                    {serviceType === "ict" ? (
                      <>
                        <div className="inv_data">実施日時・Day</div>
                        <div className="inv_time">{extractDateAndTime(convertUTCToJST(workshop?.date))}</div>
                      </>
                    ) : (
                      <>
                    {workshop?.date1 && (
                      <>
                        <div className="inv_data">実施日時・Day1</div>
                        <div className="inv_time">{extractDateAndTime(convertUTCToJST(workshop?.date1))}</div>
                      </>
                    )}
                    {workshop?.date2 && (
                      <>
                        <div className="inv_data mt-2">実施日時・Day2</div>
                        <div className="inv_time">{extractDateAndTime(convertUTCToJST(workshop?.date2))}</div>
                      </>
                    )}
                    </>
                    )}
                  </div>
                </div>
              )}
            </>

            <>
              {windowWidth <= 768 && (
                <div className="col-md-3 d-flex align-items-center justify-content-start">
                  <div className="text-start gapbottom pt-2 nav-hd equal">
                    {serviceType === "ict" ? (
                      <>
                        <div className="w50">
                          <div className="inv_data">実施日時・Day</div>
                          <div className="inv_time">{extractDateAndTime(convertUTCToJST(workshop?.date))}</div>
                        </div>
                      </>
                    ) : (
                      <>
                    <div className="w50">
                      {workshop?.date1 && (
                        <>
                          <div className="inv_data">実施日時・Day1</div>
                          <div className="inv_time">{extractDateAndTime(convertUTCToJST(workshop?.date1))}</div>
                        </>
                      )}
                    </div>
                    <div className="w50 marginTop_-8px">
                      {workshop?.date2 && (
                        <>
                          <div className="inv_data mt-2">実施日時・Day2</div>
                          <div className="inv_time">{extractDateAndTime(convertUTCToJST(workshop?.date2))}</div>
                        </>
                      )}
                    </div>
                    </>
                    )}
                  </div>
                </div>
              )}
            </>

          </div>
        </div>
      </div>
    </>
  )
}

export default QuestionSubHeader
